import React, { useContext, useState } from "react";
import styles from "./ReadMoreModal.module.scss";
import { AppContext } from "../../context/AppContext";
import Modal from "react-modal";
import { ReactComponent as whatsappIcon } from "../../assets/whatsapp.svg";
import { ReactComponent as emailIcon } from "../../assets/email.svg";
import { ReactComponent as twitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as clipboardIcon } from "../../assets/clipboard.svg";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";
import ArtistAvatar from "../../components/ArtistAvatar/ArtistAvatar";
import { ReactComponent as LockIcon } from "../../assets/lock-icon.svg";
import everethArtworkHidden from "../../assets/evereth_artwork.png";
import { strings } from "../../strings";
import Button from "../../components/Button/Button";

export default function ReadMoreModal({ isVisible }) {
  const ctx = useContext(AppContext);
  const [copied, setCopied] = useState(false);
  const { toggleModal, selectedArtist } = ctx;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "black",
      border: "0px",
      width: "65%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      borderRadius: "0px",
      padding: "0px",
      overflowX: "hidden",
      paddingBottom: "80px",
      // height: "75vh",
    },
    overlay: {
      backgroundColor: "rgba(71, 72, 79, 0.8)",
    },
  };
  return (
    <div className={styles.modal}>
      <Modal
        isOpen={isVisible}
        onRequestClose={() => {
          toggleModal(null);
        }}
        // className={styles.readMoreModal}
        style={customStyles}
        contentLabel="Share Modal"
      >
        <div className={styles.artist}>
          {/* {selectedArtist && <ArtistAvatar image={selectedArtist.img} />} */}
        </div>
        {selectedArtist && (
          <div className={styles.artwork}>
            <div
              className={`${styles.artworkImage} ${
                selectedArtist.name == "MARA" ? styles.mara : ""
              }`}
            >
              <img src={selectedArtist.artwork} alt="artwork" />
              {selectedArtist.revealed == false && (
                <div className={styles.hide}>
                  <LockIcon />
                  Artwork to be
                  <br />
                  revealed soon
                </div>
              )}
            </div>
            <div className={styles.artworkDescription}>
              <b className={styles.name}>{selectedArtist.name}</b>
              <h4 className={styles.artworkHeader}>{strings.artworkHeader}</h4>
              <span
                dangerouslySetInnerHTML={{ __html: selectedArtist.description }}
              />
              <div className={styles.actions}>
                <div className={styles.links}>
                  <Button
                    text={
                      selectedArtist.name == "1 of 1 BAG"
                        ? "SOLD OUT"
                        : strings.artworkBtn
                    }
                    action={() => {
                      window.open(selectedArtist.link, "_blank");
                    }}
                  />
                  <b
                    dangerouslySetInnerHTML={{ __html: selectedArtist.price }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <CloseIcon className={styles.close} onClick={() => toggleModal(null)} />
      </Modal>
    </div>
  );
}
